export const CARTO_BASEMAP_URL = `https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png?key=${_CARTO_API_KEY_}`
